
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.188 5h1.625l.219.656L11.97 11h.031v.063l.938 2.594.063.156v1.188h-2v-.844l-.406-1.156H7.408l-.406 1.156v.844h-2v-1.188l.063-.156.938-2.594V11h.031l1.938-5.344zM22 5h2v18.688l2.594-2.594L28 22.5l-4.281 4.313-.719.688-.719-.688L18 22.5l1.406-1.406L22 23.688V5zM9 8.656L8.156 11h1.688zM5 17h8v2.406l-.281.313L7.438 25h5.563v2h-8v-2.406l.281-.313L10.563 19H5v-2z"}})])
          )
        }
      }
    